<template>
    <div class="login">
        <div class="login_logo">
            <img class="login_logo_img" src="@/assets/images/login/logo.png" />
        </div>
        <div class="login_main">
            <div class="main_right">
                <div class="login-form">
                    <div class="flex flex-jc-sb flex-ac-c w100 mb30">
                        <div class="form-title"> 找回密码 </div>
                        <el-button type="primary" link @click="goLogin">返回登录></el-button>
                    </div>
                    <div class="form-tab">
                        <el-steps class="wd900" align-center :space="300" :active="tabIndex" finish-status="success">
                            <el-step title="微信扫码" />
                            <el-step title="重置密码" />
                            <el-step title="完成重置" />
                        </el-steps>
                    </div>

                    <div v-if="tabIndex === 0" class="item flex-ai-c">
                        <el-button class="mb20 mt20" size="large" link>
                            请使用微信扫描二维码注册
                        </el-button>
                        <!-- <img class="qr-code" :src="qrUrl" alt="QR Code" @click="generate()" /> -->
                        <div class="qr-code-container" v-if="qrCodeUrl">
                            <div class="iframe-wrapper">
                                <iframe :src="qrCodeUrl" frameborder="0"></iframe>
                            </div>
                        </div>

                        <div class="qr-code-container" v-else>正在加载二维码...</div>
                    </div>

                    <div v-if="tabIndex === 1" class="item wd400 mt20">
                        <!--  <div class="form-item">
                            <i class="icon user"></i>
                            <el-input v-model="loginForm.userName" placeholder="账号昵称" />
                        </div> -->
                        <div class="form-item">
                            <i class="icon lock"></i>
                            <el-input v-model="loginForm.passWord" placeholder="请输入密码" type="password" show-password />
                        </div>
                        <div class="form-item">
                            <i class="icon lock"></i>
                            <el-input v-model="loginForm.confirmPassWord" placeholder="请确认密码" type="password"
                                show-password />
                        </div>
                        <!-- <div class="form-item">
                            <i class="icon phone"></i>
                            <el-input v-model="loginForm.phone" placeholder="请输入手机号" />
                        </div> -->
                        <div class="text">
                            柏斯顿账号服务需要联网，并获取您的账号、所在区域、浏览器设置信息，以及您主动上传的基本资料和身份信息。点击“注册”，即表示您同即表示您同意上述内容及<span
                                style="color: #2F78EC;">柏斯顿账号用户协议</span>.
                        </div>
                        <!-- <div class="form-item captcha">
                            <i class="icon code"></i>
                            <el-input v-model="loginForm.captcha" placeholder="请输入验证码" />
                            <img class="captcha-img" :src="captchaImgUrl" @click="refreshCaptcha" />
                        </div> -->
                        <button class="login-btn" @click="loginSubmit()">确认</button>
                    </div>
                    <div v-if="tabIndex === 2" class="item wd400 mt20 flex-ai-c">
                        <div class="font26 fw900 c-391A69">柏斯顿</div>
                        <div class="font15 c-6C6C6C mt32">国产楼控第一优选品牌</div>
                        <el-icon class="mt45" color="#67C23A" size="80">
                            <SuccessFilled />
                        </el-icon>
                        <div class="font15 fw900 mt45">你的帐户： 重置成功</div>
                        <el-button class="mt50" @click="goLogin" type="primary">前往登录</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { reactive, ref, onMounted, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { useRouter, useRoute } from 'vue-router';
// import { useUserStore } from '@/store/user'; // Pinia store
import { SYSTEM_NAME, URL } from '@/constant/Const';
import { login, getRouteList, getloginimage, getLoginQrCodeMima, getLoginOpenId, userWxForgetPassword } from "@/api/auth/login/index";
import { refreshRoutes } from '@/router';
import QRCode from 'qrcode'

const route = useRoute()
const router = useRouter();
// const userStore = useUserStore();

const systemName = SYSTEM_NAME;
const url = URL;

const loginForm = reactive({
    passWord: '',
    confirmPassWord: '',
});
const tabIndex = ref(0);
const loading = ref(false);
const isWindows = ref(true);
const mainRightWidth = ref('23vw');
const mainInputWidth = ref('15vw');
const captchaImgUrl = ref('');
const qrCodeUrl = ref('');

const loginRef = ref(null);
const qrUrl = ref(null);

const openId = ref('');

watch(
    () => route.query,
    () => {
        handleWxCallback()
    }
)

onMounted(() => {
    // refreshCaptcha();
    checkUserAgent();
    generate();
});

// 监听路由参数变化
const handleWxCallback = () => {
    const code = route.query.code
    const state = route.query.state

    if (code) {
        console.log('拿到微信code:', code)
        // 调后端登录
        getLoginOpenId({ code }).then(res => {
        if (res.code == 0 || res.code == 1) {
            openId.value = res.data
            tabIndex.value++
        }
        }).catch((err) => {
            console.log(err);
            ElMessage.error('登录失败，请稍后重试！');
        });
    }
}

const generate = async () => {
    getLoginQrCodeMima().then(resp => {
        console.log(resp);
        const url = resp.data;
        console.log(url);

        qrCodeUrl.value = url;
    }).catch((err) => {
        console.log(err);

        // ElMessage.error('获取二维码失败，请稍后重试！');
    });
}

const goLogin = () => {
    router.replace('/login');
}

function checkUserAgent() {
    const userAgent = navigator.userAgent;
    if (userAgent.includes('Windows') || userAgent.includes('Win')) {
        isWindows.value = true;
    } else {
        isWindows.value = false;
        mainRightWidth.value = '70vw';
        mainInputWidth.value = '53vw';
    }
}

function refreshCaptcha() {
    loginForm.uuid = uuidCompact();
    captchaImgUrl.value = url + `/api/login/captcha?uuid=${loginForm.uuid}&t=${Date.now()}`;
}

function uuidCompact() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}

function loginSubmit() {
    if (!loginForm.passWord || !loginForm.confirmPassWord) {
        ElMessage.error('请输入密码、确认密码');
        return;
    }
    if (loginForm.passWord !== loginForm.confirmPassWord) {
        ElMessage.error('两次输入的密码不一致');
        return;
    }
    loading.value = true;
    userWxForgetPassword({
        passWord: loginForm.passWord,
        openId: openId.value
    }).then(res => {
        if (res.code == 0 || res.code == 1) {
            console.log(res);
            tabIndex.value++
        }
    }).catch((err) => {
    })
}
</script>

<style lang="scss" scoped>
/* Login 样式 */
.login::v-deep {
    position: relative;
    width: 100vw;
    min-height: 100vh;

    background: #0064C8 url('@/assets/images/login/beijing.png') no-repeat center;
    background-size: cover;

    display: flex;
    flex-direction: column;
    align-items: center;

    /* logo 区 */
    .login_logo {
        margin-top: clamp(40px, 8vh, 90px);
        margin-bottom: clamp(40px, 6vh, 92px);
        display: flex;
        justify-content: center;

        .login_logo_img {
            width: 250px;
            height: auto;
        }
    }

    /* 主体卡片 */
    .login_main {
        width: 90%;
        max-width: 866px;
        min-height: 620px;
        padding: 20px;

        background: #ffffff;
        border-radius: 12px;

        box-sizing: border-box;
        display: flex;

        .main_left {
            width: 40%;
            height: 100%;

            .el-carousel {
                width: 100%;

            }

            .main_img {
                width: 100%;
                object-fit: cover;
                display: block;
            }
        }

        .main_right {
            flex: 1;
            box-sizing: border-box;
            padding: clamp(20px, 3vw, 20px);

            .login-form {
                width: 100%;
                max-width: 700px;
                margin: 0 auto;
                display: flex;
                flex-direction: column;
                align-items: center;

                .form-title {
                    text-align: center;
                    font-size: 22px;
                    font-weight: 600;
                    color: #333;
                    position: relative;
                }

                .form-tab {
                    display: flex;
                    justify-content: center;

                    .form-tab-item {
                        width: 50%;
                        cursor: pointer;
                        text-align: center;
                        font-size: 18px;
                        font-weight: 600;
                        color: #333;
                        margin-bottom: 30px;
                        position: relative;

                        &::after {
                            content: '';
                            display: block;
                            width: 100%;
                            height: 2px;
                            background: #e5e5e5;
                            margin: 12px auto 0;
                        }
                    }

                    .active {
                        color: #391A69;

                        &::after {
                            background: #391A69;
                        }
                    }
                }

                .item {
                    display: flex;
                    flex-direction: column;
                    align-items: stretch;
                }

                .qr-code {
                    width: 200px;
                    height: 200px;
                }

                .form-item {
                    display: flex;
                    align-items: center;
                    height: 44px;
                    border: 1px solid #e5e8ef;
                    border-radius: 4px;
                    padding: 0 12px;
                    margin-bottom: 16px;
                    box-sizing: border-box;

                    .el-input {
                        flex: 1;
                        border: none;
                        outline: none;
                        font-size: 14px;
                        color: #333;

                        &::placeholder {
                            color: #b0b4bd;
                        }

                        .el-input__wrapper {
                            box-shadow: none !important;
                        }
                    }

                    .icon {
                        width: 18px;
                        height: 18px;
                        margin-right: 8px;
                        background-size: contain;
                        background-repeat: no-repeat;

                        &.user {
                            background-image: url('@/assets/images/login/shuruzhanghao.png');
                        }

                        &.lock {
                            background-image: url('@/assets/images/login/shurumima.png');
                        }

                        &.phone {
                            background-image: url('@/assets/images/login/shoujihao.png');
                        }

                        &.code {
                            background-image: url('@/assets/images/login/shuruyanzhengma.png');
                        }
                    }
                }

                .text {
                    font-weight: 400;
                    font-size: 10px;
                    color: #000000;
                }

                .captcha {

                    .captcha-img {
                        width: 90px;
                        height: 32px;
                        background: #e5e5e5;
                        border-radius: 4px;
                    }
                }

                .login-btn {
                    margin-top: 20px;
                    height: 44px;
                    background: #3a7afe;
                    border: none;
                    border-radius: 4px;
                    color: #fff;
                    font-size: 16px;
                    cursor: pointer;

                    &:hover {
                        background: #2f6fe4;
                    }
                }
            }

        }
    }

}

.c-391A69 {
    color: #391A69;
}

.c-6C6C6C {
    color: #6C6C6C;
}

@media screen and (max-width: 992px) {
    .login {
        .login_main {
            .main_left {
                display: none;
            }

            .main_right {
                width: 100%;
            }
        }
    }
}

@media screen and (max-width: 576px) {
    .login_main {
        padding: 16px;
        border-radius: 8px;
    }
}

.qr-code-container {
    width: 300px;
    height: 300px;
    overflow: hidden;
    position: relative;
    text-align: center;
}

.qr-code-container::v-deep iframe {
    width: 100%;
    height: 400px;
    border: none;
    margin-top: -60px;
    transform: scale(0.7);
    transform-origin: center;
}
</style>
